// useStyles.js
import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '100vh', // Full viewport height
  },
  content: {
    flex: 1, // Fills the remaining space
    overflow: 'auto', // Makes content scrollable if needed
    backgroundColor: '#FFFFFF',
  },
  toolbar: {
    paddingLeft: '0px',
  },
  appBar: {
    backgroundColor: '#fafafa',
    boxShadow: 'none',
    borderBottom: 'solid 1px #f1f1f1',
  },
  title: {
    flexGrow: 1,
    textAlign: 'center',
    color: theme.palette.primary.main,
    fontSize: '1.5rem',
  },
  logo: {
    cursor: 'pointer',
    width: '150px',
    height: '50px',
    backgroundPosition: 'center',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
  },
  // ... other styles
}));
